var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var SchemaPropertyService = /** @class */ (function (_super) {
            __extends(SchemaPropertyService, _super);
            function SchemaPropertyService(injectedBreeze, $q) {
                return _super.call(this, injectedBreeze, $q) || this;
            }
            SchemaPropertyService.prototype.getSchemaProperty = function (id) {
                return this.fetchById(id, "SchemaProperty");
            };
            SchemaPropertyService.prototype.getSchemaPropertyByUniqueId = function (id) {
                var d = this.$q.defer();
                var query = this.breezeModule.EntityQuery
                    .from("SchemaProperties")
                    .where('uniqueIdentifier', '==', id);
                this.executeQuery(query).then(function (r) {
                    //TODO: Change this to work with the current SchemaProperty
                    d.resolve(r[0]);
                });
                return d.promise;
            };
            SchemaPropertyService.prototype.createNewSchemaProperty = function () {
                var newSchemaProperty = this.createNewEntity("SchemaProperty");
                newSchemaProperty.isIndexed = false;
                newSchemaProperty.required = false;
                newSchemaProperty.isSystemLevel = false;
                newSchemaProperty.uniqueIdentifier = services.UtilityService.generateGuidComb();
                return newSchemaProperty;
            };
            return SchemaPropertyService;
        }(services.DataService));
        services.SchemaPropertyService = SchemaPropertyService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('SchemaPropertyService', ['breeze', '$q']);
